import { Component, OnInit } from '@angular/core';
import { ProductService } from 'src/app/shared/services/product.service';
import { take } from 'rxjs/operators';
import * as _ from "lodash";
import { Product } from 'src/app/shared/models/product';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-toppings-settings',
  templateUrl: './toppings-settings.component.html',
  styleUrls: ['./toppings-settings.component.scss']
})
export class ToppingsSettingsComponent implements OnInit {
  toppings: any;
  categories: any;
  choosenTopping: any;
  submitted = false;
  choosenToppingGroupForm: FormGroup;
  constructor(private producService: ProductService, private formBuilder: FormBuilder) { }
  ngOnInit() {
    this.producService.getToppings().valueChanges().subscribe(toppings => {
      this.toppings = toppings;
      this.getAllCategory();
    });
  }
  getAllCategory() {
    const productsByCat = _.uniqBy(this.toppings, 'productCategory');
    _.forEach(productsByCat, product => {
      this.categories.push(product.productCategory)
    })
  }

  chooseProduct(product) {
    let s = _.map(this.toppings, (value, key) => {
      if (key == product.key) {
        return { ...value, key }
      }
    });
    s = _.filter(s, (product) => { return product !== undefined }); 
    this.choosenTopping = s[0];
    this.choosenToppingGroupForm = this.formBuilder.group({
      productName: [this.choosenTopping.productName, Validators.required],
      productId: [this.choosenTopping.productId, Validators.required],
      productCategory: [this.choosenTopping.productCategory, Validators.required],
      productPrice: [this.choosenTopping.productPrice, [Validators.required]],
      productDescription: [this.choosenTopping.productDescription, [Validators.required]],
      productImageUrl: [this.choosenTopping.productImageUrl],
      productAdded: moment().unix()
    }, {
    });
  }
  get f() { return this.choosenToppingGroupForm.controls; }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.choosenToppingGroupForm.invalid) {
      return;
    }
    this.producService.updateTopping(this.choosenToppingGroupForm.value, this.choosenTopping.key)
  }
  onReset() {
    this.submitted = false;
    this.choosenToppingGroupForm.reset();
  }
}
